import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { OrdersState, ORDERS_SLICE_NAME } from './models';

export const ordersSelector = (state: RootState): OrdersState => state[ORDERS_SLICE_NAME];

export const selectOrdersIsLoading = createSelector(ordersSelector, (state: OrdersState) => state.isLoading);

export const selectOrders = createSelector(ordersSelector, (state: OrdersState) => state.orders);

export const selectAppliedFilters = createSelector(ordersSelector, (state: OrdersState) => state.appliedFilters);

export const selectPagination = createSelector(ordersSelector, (state: OrdersState) => state.pagination);

export const selectOrder = createSelector(ordersSelector, (state: OrdersState) => state.order);
